import React, { useState } from 'react'
import { useEffect } from 'react';
import { useCallback } from 'react';
import { Dropdown, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import FilterScreen from '../common/FilterScreen';
import PaginationDataTable from '../common/PaginationDataTable';
import dateUtils from '../common/utilities/DateUtilities';
import { TableColumns } from './TableColumns';
import ExpandRowPaginationTable from '../common/ExpandRowPaginationTable';  

const TableFilter = (props) => {
    const navigate = useNavigate();
    const [filterTableColumns, setFilterTableColumns] = useState([]);
    
    const [showObjectModel, setShowObjectModel] = useState(false);
    const [activeModelRecordData, setActiveModelRecordData] = useState(null)
    const [showFilter, setShowFilter] = useState(false);
    const [columnData, setColumnData] = useState(null)
    const [dateTimeFilterArr, setDateTimeFilterArr] = useState({
        searchFilters: [],
        sortRules: []
    });
    const [sortTableData, setSortTableData] = useState({
        searchFilters: [],
        sortRules: []
    });
    const [filterScreenColumns, setFilterScreenColumns] = useState({
        columnName: "",
        show: false
    })

    const handleSearchFilter = (columnName, columnType) => {
        setShowFilter(prev => !prev);
        setFilterScreenColumns({
            columnName: columnName,
            show: true,
        })
        setColumnData([columnName, columnType])
    }

    const handleTableActions = (rowData, actionData) => {
        if (actionData.type === "navigate") {
            var fetchDetails, detail_Url;
            if (props.requestObjects) {
                let newURl = `${props.requestObjects.name}/${rowData.name}`
                fetchDetails = {
                    recordData: rowData,
                    requestObjIs: props.requestObjects,
                    type: "fetch",
                };
                detail_Url = actionData.navigatePath.replaceAll(actionData.replaceData, newURl);
            } else {
                fetchDetails = {
                    recordData: rowData,
                    type: "fetch",
                };
                detail_Url = actionData.navigatePath.replaceAll(actionData.replaceData, rowData.id);
            }
            navigate(detail_Url, { state: fetchDetails });
        } else if (actionData.type === "alert") {

            var deleteUrl = actionData?.navigatePath?.replaceAll(actionData.replaceData, rowData.id)
            actionData.action(deleteUrl,props.refreshTableData, rowData)
        } else if (actionData.type === "model") {
            props.showRecordUpdateModel(rowData)
        }
    }

    // Table Action Buttons
    const getTableActionButtons = (row, actionIs) => {
        return (
            <Dropdown className='custom-dropdown'>
                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                    <i className="fa fa-chevron-down"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {actionIs.length !== 0 && actionIs.map((data, i) => {
                        return (<>
                            <Dropdown.Item
                                href={undefined}
                                key={`${i}-a`}
                                onClick={() =>
                                    handleTableActions(row, data)}
                            >
                                <i className={`${data.iconClass} me-2`}></i> {data.name}
                            </Dropdown.Item>
                        </>)
                    }
                    )}
                </Dropdown.Menu>
            </Dropdown >
        )
    }

    useEffect(() => {
        if (props) {
            fetchCustomColumns();
        }
    }, [sortTableData, showFilter])

    const fetchCustomColumns = useCallback(
        () => {
            let options = [];
            let actions = [];
            TableColumns(props.tableName).map((d, i) => {
                if (d.name !== "Actions") {
                    options.push(
                        {
                            id: d.value,
                            name: <div className={`tableHeaders ${sortTableData.searchFilters.length !== 0 && (sortTableData.searchFilters.some((data) => data.columnName === d.value)) ? "active" : ""}`} key={i}>
                                <div className='custom-dropdown'>
                                    <div className='filter-screen'><i className='fa-solid fa-filter header-filter' onClick={() => handleSearchFilter(d.value, d.type)}></i>{d.name}</div>
                                    {(filterScreenColumns.columnName === d.value && filterScreenColumns.show === true) &&
                                        <div className='custom-menu'>
                                            {columnData && callFilterScreen()}
                                        </div>
                                    }
                                </div>
                                <div div className="order" >
                                    <i className={`fa-solid fa-caret-up ${sortTableData.sortRules.length !== 0 && (sortTableData.sortRules.some((data) => data.columnName === d.value && data.operation === "ASC")) ? "active" : ""}`} onClick={() => handleAscDescSortRule(d.value, "ASC")}></i>
                                    <i className={`fa-solid fa-caret-down ${sortTableData.sortRules.length !== 0 && (sortTableData.sortRules.some((data) => data.columnName === d.value && data.operation === "DESC")) ? "active" : ""}`} onClick={() => handleAscDescSortRule(d.value, "DESC")}></i>
                                </div >
                            </div >,
                            selector: (row, index) => <div className="ellipses">
                                {row[d.value] === undefined ? "Not Found" :
                                    row[d.value] === true ? "Yes" :
                                        row[d.value] === false ? "No" :
                                            typeof row[d.value] === "object" ? <button className='show-modal-btn' onClick={() => handleShowModelBoxPopup(row[d.value])}>View Data</button> :
                                                (d.type === "DATE" || d.type === "DATETIME") ? dateUtils.getFormattedDateTimeByTimeStamp(row[d.value]) :
                                                    row[d.value]}
                            </div>,
                            sortable: false,
                        },
                    )
                }
            }
            )

            TableColumns(props.tableName).map((data, i) => {
                if (data.name === "Actions") {
                    actions.push(...data.value);
                }
            })

            options.push({
                id: "action",
                name: "Action",
                selector: (row, index) => getTableActionButtons(row, actions),
                width: "100px",
                sortable: false
            });
            setFilterTableColumns(options)
        },
        [props, sortTableData, showFilter],
    );

    const callFilterScreen = () => {
        return (
            <FilterScreen sortTableData={sortTableData} columnData={columnData} sortTableDataIs={sortTableData} dateTimeFilterDataIs={dateTimeFilterArr} handleApplyFilter={handleApplyFilter} />
        )
    }

    const handleApplyFilter = (searchFilterArr, name, isFilterApply, dateTimeFilterArrayData) => {
        if (isFilterApply) {
            if (searchFilterArr.length > 0) {
                const found = searchFilterArr.some((data) => (data.columnValue === "" || data.operation === ""));
                if (!found) {
                    setSortTableData({
                        ...sortTableData, searchFilters: [...searchFilterArr]
                    })
                    setColumnData(null)
                    
                    setFilterScreenColumns({
                        columnName: name,
                        show: false,
                    })

                    setDateTimeFilterArr({
                        ...dateTimeFilterArr, searchFilters: [...dateTimeFilterArrayData]
                    })
                }
            }
        } else {
            setSortTableData({
                ...sortTableData, searchFilters: [...searchFilterArr]
            });

            setDateTimeFilterArr({
                ...dateTimeFilterArr, searchFilters: [...dateTimeFilterArrayData]
            })

            setColumnData(null)
            setFilterScreenColumns({
                columnName: "",
                show: true,
            })
        }

    }

    // ============= Table Record Ascending/Descending ============== //
    const handleAscDescSortRule = (name, sortType) => {
        const _sortTableDataObj = [...sortTableData.sortRules];
        const found = _sortTableDataObj.some((data) => data.columnName === name)
        if (found) {
            const sortOperation = _sortTableDataObj.some((data) => ((data.operation === sortType) && (data.columnName === name)));
            if (sortOperation) {
                _sortTableDataObj.splice(_sortTableDataObj.findIndex((data) => data.columnName === name), 1);
            } else {
                _sortTableDataObj.splice(_sortTableDataObj.findIndex((data) => data.columnName === name), 1, {
                    columnName: name,
                    operation: sortType
                });
            }
        } else {
            _sortTableDataObj.push({
                columnName: name,
                operation: sortType
            });
        }

        setSortTableData({
            ...sortTableData, sortRules: _sortTableDataObj
        });
        setDateTimeFilterArr({
            ...dateTimeFilterArr, sortRules: _sortTableDataObj
        });
    }

    const handleShowModelBoxPopup = (data) => {
        setActiveModelRecordData(data);
        setShowObjectModel(true)
    }

    const viewTableRecord = useCallback(
        () => {
            return (
                <>
                    {filterTableColumns.length != 0 &&
                        props?.expandableRows ?
                                <ExpandRowPaginationTable
                                paginationUrl={props.tableUrl}
                                search={true}
                                paginationStatus={props.paginationStatus}
                                columns={filterTableColumns} drawCount={props.drawCount}
                                filters={sortTableData} />
                            :
                            <PaginationDataTable
                                paginationUrl={props.tableUrl}
                                specificFilters={props.specificFilters}
                                search={true}
                                paginationStatus={props.paginationStatus}
                                columns={filterTableColumns} drawCount={props.drawCount}
                                filters={sortTableData} />
                    }
                </>
            )

        },
        [props, filterTableColumns, sortTableData],
    );

    return (
        <>
            {viewTableRecord()}
            <Modal show={showObjectModel} onHide={() => setShowObjectModel(false)}>
                <Modal.Body>
                    <button className='modal-close-btn' onClick={() => setShowObjectModel(false)}>
                        <i className='fa fa-times'></i>
                    </button>
                    <pre>
                        {activeModelRecordData != null && (JSON.stringify(activeModelRecordData, null, 2))}
                    </pre>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default TableFilter